export default "__VITE_ASSET__B42kGvpE__"